/*
 * Developed by CQ Inversiones SAS. Copyright ©. 2019 - 2024. All rights reserved.
 * Desarrollado por CQ Inversiones SAS. Copyright ©. 2019 - 2024. Todos los derechos reservados.
 */

/*
* Project:      frontend
* Developed by: Jhoana Marcela Rodriguez Fernandez
* Date:         5/3/2024 - 11:40
* Module name:  frontend
* File name:    settings.routes.ts
* IDE:          WebStorm
*/

import {Routes} from '@angular/router';
import {MkadContractsService, MkadCustomersService} from '@shared/services';
import {headerTitle} from '@shared/utils';
import {customersValidations, systemValidations} from '@core/constants/users-module-permissions.const';
import CustomersAdminPanelsComponent from './modules/panel-admin/customers-admin-panels';

export const SETTING_ROUTE_LIST: Routes = [
  {path: '', redirectTo: 'panel', pathMatch: 'prefix'},
  {
    path: 'panel',
    component: CustomersAdminPanelsComponent,
    data: customersValidations.panel,
  },
  {
    path: 'administration',
    title: headerTitle('Administration'),
    data: customersValidations.administration,
    loadComponent: () => import('src/app/modules/panel-admin/system-admin-panel'),
  },
  {
    path: 'customers',
    title: headerTitle('Customers'),
    data: customersValidations.customersList,
    loadComponent: () => import('@customers-admin//customers/container/customer-container'),
    providers: [MkadCustomersService],
  },
  {
    path: 'contracts',
    data: customersValidations.contractsList,
    title: headerTitle('Contracts'),
    loadComponent: () => import('@customers-admin//contracts/contracts-list'), providers: [MkadContractsService],
  },
  {
    path: 'contacts',
    data: customersValidations.contactsList,
    title: headerTitle('Contacts'),
    loadComponent: () => import('@customers-admin/contacts/contacts-list'), providers: [],
  },
  {
    path: 'groups',
    data: customersValidations.groupsList,
    title: headerTitle('Group'),
    loadComponent: () => import('@customers-admin/groups/groups-list'),
  },
  {
    path: 'users',
    data: customersValidations.usersList,
    loadComponent: () => import('@customers-admin/users/users-list'),
  },
  {
    path: 'locations',
    data: customersValidations.locationsList,
    loadComponent: () => import('@customers-admin/locations/locations-list'),
  },
  {
    path: 'sensors',
    data: systemValidations.sensors,
    loadComponent: () => import('@system-admin/sensors/sensors-list'),
  },
  {
    data: systemValidations.defaultParameters,
    path: 'parameters',
    loadComponent: () => import('@system-admin/parameters/parameters-list'),
  },
  {
    path: 'commands',
    data: systemValidations.defaultCommands,
    loadComponent: () => import('@system-admin/commands/commands-list'),
  },
  {
    path: 'icons',
    data:systemValidations.icons,
    loadComponent: () => import('@system-admin/icons/icons-list'),
  },
  {
    path: 'device-model',
    data: systemValidations.deviceModel,
    loadComponent: () => import('@system-admin/device-model/device-model-list'),
  },
  {
    path: 'devices',
    data: systemValidations.devices,
    loadComponent: () => import('@system-admin/devices/devices-list'),
  },
  {
    path: 'triggers',
    data: customersValidations.triggersList,
    loadComponent: () => import('@customers-admin/triggers/triggers-list'),
  },
  {
    path: 'device-customization',
    data: customersValidations.customization,
    loadComponent: () => import('@customers-admin/customer-device/customer-device-list'),
  },
  {path: '**', redirectTo: 'panel', pathMatch: 'prefix'},
];
